import { Willpay } from "@tvg/ts-types/Race";

export const getSelectionListWillPays = (willPays: Willpay[]) => {
  const willPaysTabs = willPays.map((item, index) => ({
    title: `$${item.wagerAmount} ${item.type.name}`,
    description: `${
      item.legResults
        ? item.legResults
            .map((lr) => lr.winningBi)
            .join(",")
            .replace(/,/g, " | ")
        : ""
    } | *`,
    value: index.toString()
  }));

  return willPaysTabs;
};
